import React, { useEffect, useRef, useState } from "react";
import emogy from "../../assets/images/emogy.svg";
import sendicon from "../../assets/images/send-icon.svg";
import defaultUser from "assets/images/avatar.svg";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { toast } from "react-toastify";

const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/;
const numericPattern = /\d{10,}/;

const ChatBox = ({
  chatDetails,
  user,
  messages,
  setCurrentMsg,
  handleSend,
  currentMsg,
}) => {
  const [showEmoji, setShowEmoji] = useState("");
  const bottomRef = useRef(null);
  const emojiRef = useRef(null);
  const emojiBtnRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !emojiRef?.current?.contains(e.target) &&
        !emojiBtnRef?.current?.contains(e.target)
      ) {
        setShowEmoji(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleAddEmoji = (emojiData) => {
    const emoji = emojiData.native;
    setCurrentMsg((prev) => prev + emoji);
  };

  const groupMessagesByDay = (messages) => {
    return (
      messages?.length > 0 &&
      messages?.reduce((groups, message) => {
        const now = new Date();
        const messageDate = new Date(message?.created).toDateString();
        const daysAgo =
          (now - new Date(message?.created)) / (1000 * 60 * 60 * 24);

        let groupLabel = messageDate;
        if (daysAgo < 1) groupLabel = "Today";
        else if (daysAgo < 2) groupLabel = "Yesterday";

        if (!groups[groupLabel]) groups[groupLabel] = [];
        groups[groupLabel].push(message);
        return groups;
      }, {})
    );
  };

  const groupedMessages = groupMessagesByDay(messages);

  let userType = "clientId";
  if (user?.roleType === "CLIENT")
    userType = chatDetails?.pilotId ? "pilotId" : "adminId";
  else if (user?.roleType === "PILOT")
    userType = chatDetails?.clientId ? "clientId" : "adminId";
  else if (user?.roleType === "ADMIN")
    userType = chatDetails?.pilotId ? "pilotId" : "clientId";

  // === validation for send ===
  const hasEmailOrNumber =
    emailPattern.test(currentMsg || "") ||
    numericPattern.test(currentMsg || "");
  const isEmpty = !currentMsg?.trim();

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (isEmpty) return;
    console.log("++++hasEmailOrNumber", hasEmailOrNumber);
    if (hasEmailOrNumber) {
      toast.warn("Email and digits are not allowed!");
      return;
    }

    // only call parent handleSend if valid
    handleSend(e);
  };

  useEffect(() => {
    // show toast instantly when typing invalid content
    if (!currentMsg) return;

    const hasInvalid =
      emailPattern.test(currentMsg) || numericPattern.test(currentMsg);

    if (hasInvalid) {
      toast.warn("Email and digits are not allowed!");
    }
  }, [currentMsg]);

  return (
    <div className="chatbox">
      {chatDetails ? (
        <div className="modal-dialog-scrollable">
          <div className="modal-content">
            <div className="msg-head">
              <div className="row">
                <div className="col-8">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                      <img
                        className="user-img border border-secondary"
                        src={`${user?.baseS3Url}${chatDetails?.[userType]?.avatar}`}
                        alt="user img"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = defaultUser;
                        }}
                      />
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <h3 className="m-0">
                        {chatDetails?.[userType]?.fullName || "Unknown User"}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-body">
              <div className="msg-body">
                <ul>
                  {Object.entries(groupedMessages || {}).map(
                    ([label, messages]) => (
                      <React.Fragment key={label}>
                        <div className="divider">
                          <h6>
                            {label === "Today" || label === "Yesterday"
                              ? label
                              : new Date(label).toLocaleDateString("en-US", {
                                  weekday: "long",
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })}
                          </h6>
                        </div>
                        {messages?.map((message, i) => (
                          <li
                            key={i}
                            className={`${
                              message?.senderId === user?._id
                                ? "reply"
                                : "sender"
                            } pe-4`}
                          >
                            <p>{message?.message}</p>
                            <span className="time">
                              {new Date(message?.created).toLocaleString(
                                "en-US",
                                {
                                  hour: "numeric",
                                  minute: "numeric",
                                  hour12: true,
                                }
                              )}
                            </span>
                          </li>
                        ))}
                      </React.Fragment>
                    )
                  )}
                  <div ref={bottomRef} />
                </ul>
              </div>
            </div>

            <div className="send-box">
              <form onSubmit={handleFormSubmit}>
                <div className="position-relative w-100 flex-grow-1">
                  <input
                    value={currentMsg}
                    type="text"
                    className="form-control"
                    placeholder="Write a message..."
                    onChange={(e) => {
                      // allow typing anything, we'll block on send
                      setCurrentMsg(e.target.value);
                    }}
                  />
                  <button
                    className="bg-transparent text-start emogy-icon"
                    type="button"
                    ref={emojiBtnRef}
                    onClick={() => setShowEmoji(!showEmoji)}
                  >
                    <img alt="" src={emogy} />
                  </button>

                  {showEmoji && (
                    <div className="emoji-picker-box" ref={emojiRef}>
                      <Picker
                        data={data}
                        onEmojiSelect={handleAddEmoji}
                        showPreview={false}
                      />
                    </div>
                  )}
                </div>

                <button
                  className="bg-transparent text-end flex-shrink-0"
                  type="submit"
                  disabled={isEmpty || hasEmailOrNumber}
                  title={
                    hasEmailOrNumber ? "Email and digits are not allowed!" : ""
                  }
                >
                  <img alt="" src={sendicon} />
                </button>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100">
          Welcome to Chat Box
        </div>
      )}
    </div>
  );
};

export default ChatBox;
